import MembAccnDtlInfoInqApi from "Apis/MembAccnDtlInfoInqApi";
import { useEffect, useState } from "react";
import { Link ,useNavigate } from "react-router-dom";
import MembGameSvcMnyApi from "Apis/MembGameSvcMnyApi";
import { Helmet } from 'react-helmet-async';
import GameSvcCdRelLstApi from "Apis/GameSvcCdRelLstApi";
import MembGameRelLstApi from "Apis/MembGameRelLstApi";
import MgpStore from "Stores/Store";

const MembGameSvcMnyUi = ({langData}:any) => {
    const navigate = useNavigate();
    const [membGameMnyState,setMembGameMnyState] = useState<any>();
    const [membGameSvcMny,setMembGameSvcMny] = useState();
    const [membGameYrelLstState,setMembGameYrelLstState] = useState<any>([]);
    const [gameYrelLstSelectMenuStates, setGameYrelLstSelectMenuStates] = useState(false);
    const [selectedSvcCdState,setselectedSvcCdState] = useState("");
    const [selectedSvcNmState,setselectedSvcNmState] = useState("");
    const [gameMnyNmState,setGameMnyNmState] = useState("");
    var popupX = Math.round(window.screenX + (window.outerWidth/2) - (500/2));
    var popupY = Math.round(window.screenY + (window.outerHeight/2) - (765/2));
    const GameMnyPopFunc = (e:any)=>{
        window.open(e,"_blank","width=500,height=765 left="+popupX+"top="+popupY);
    }
    useEffect(()=> {
         MembGameRelLstApi().then((resp)=>(
            setMembGameYrelLstState(resp.yrelLst),
            setselectedSvcCdState(resp.yrelLst[0].gameSvcCd),
            setselectedSvcNmState(resp.yrelLst[0].gameNm),
            setMembGameSvcMny(resp.yrelLst[0].totMny),
            setGameMnyNmState(resp.yrelLst[0].gameMnyNm)
        ));
    },[MgpStore.getState().LangSetState.Lang]);
    const GameYrelLstSelectMenuToggle = () => {
        setGameYrelLstSelectMenuStates(gameYrelLstSelectMenuStates => !gameYrelLstSelectMenuStates);
    }
    function returnOfIndex(value:string, membGameYrelLstState:any){
        let index;
        for(var i=0; i<membGameYrelLstState.length; i++){
            if(membGameYrelLstState[i].gameNm.indexOf(value) != -1){
                index=i;
            }
        }
        return index;
    }
    const SelectValueSetFunc =(value:string) => {
        var returnValue = returnOfIndex(value,membGameYrelLstState)
        if(returnValue == undefined) {
            returnValue =0;
        }
        setselectedSvcCdState(membGameYrelLstState[returnValue].gameSvcCd);
        setselectedSvcNmState(membGameYrelLstState[returnValue].gameNm);
        setMembGameSvcMny(membGameYrelLstState[returnValue].totMny);
        setGameMnyNmState(membGameYrelLstState[returnValue].gameMnyNm);
        GameYrelLstSelectMenuToggle();
        // setselectedSvcCdState(membGameYrelLstState[returnValue].gameSvcCd),
        // setselectedSvcNmState(membGameYrelLstState[returnValue].gameNm),
        //  setMembGameSvcMny(membGameYrelLstState[returnValue].totMny)
    }

    return(
        <>
        <div className="myPageCard">
            <h2>My Cash</h2>
            <div className="myPageCardCtxt">
                <ul>
                    <li className="myPageCardCtxtLi">
                        {membGameYrelLstState&&membGameYrelLstState.length != 0 ?
                        <>
                            <div 
                                className="ctxtLiTitl relative" 
                                onBlur={() => setGameYrelLstSelectMenuStates(false)}
                                tabIndex={0}
                            >
                                <p 
                                    className={gameYrelLstSelectMenuStates?'gameYrelSelectTitl active':"gameYrelSelectTitl"} 
                                    onClick={() => GameYrelLstSelectMenuToggle()}
                                > 
                                    {selectedSvcNmState&&selectedSvcNmState} 
                                </p>
                                <div className={gameYrelLstSelectMenuStates?'gameYrelWrap active':"gameYrelWrap"}>
                                    <ul>
                                        {
                                            membGameYrelLstState&&membGameYrelLstState.map((key:any, index:number) => (
                                                <li key={index} onMouseDown={()=>SelectValueSetFunc(key.gameNm)}>
                                                    {key.gameNm}
                                                </li>
                                            ))
                                        }
                                    </ul>
                                </div>
                                {/* 보유중인 캐시 */}
                            </div>
                            <div>
                                <Link to={"/MyPage/GameSvcMnyDpstLst"} className="moNone">
                                    {langData&&langData.MYPAGE_MNY_LST_DPST_BTN_01}
                                    {/* 충전내역 */}
                                </Link>
                            </div>
                        </>
                        :
                        <>
                            <div className="ctxtLiTitl relative">
                                <p>{langData&&langData.MYPAGE_GAME_REL_NO_DATA_00}</p>
                            </div>
                            <div>
                                <Link to={"/MyPage/GameSvcRelLst"} className="moNone">
                                    {langData&&langData.MYPAGE_MENU_GAME_REL_BTN_00}
                                    {/* 충전내역 */}
                                </Link>
                            </div>
                        </>
                        }
                    </li>
                    <li className="myPageCardCtxtLi">
                        {membGameYrelLstState&&membGameYrelLstState.length != 0 ?
                            <>
                                <div className="ctxtLiTitl">
                                    <h1 className="activeText gameMnyTxt">{gameMnyNmState&&gameMnyNmState} : {membGameSvcMny&&membGameSvcMny}</h1>
                                    {/* 보유중인 캐시 */}
                                </div>
                                <div>
                                {/* <Link to={`/GamePage/ShopLst?ctntKindCd=MNY&gameSvcCd=${selectedSvcCdState}`}>
                                    {langData&&langData.MYPAGE_MAIN_MNY_DPST_BTN_00}
                                </Link> */}
                                {/* bbo로 들어와서 제대로 작동안함 */}
                                {/* <Link to={`/GamePage/ShopLst?ctntKindCd=MNY&gameSvcCd=KRBBO`}>
                                    {langData&&langData.MYPAGE_MAIN_MNY_DPST_BTN_00}
                                </Link> */}
                                </div>
                            </>
                        :
                        <></>
                        }
                        {/* <button onClick={()=>GameMnyPopFunc(`${'/GameMnyDpstPop'}`)}>
                            {langData&&langData.MYPAGE_MAIN_MNY_DPST_BTN_00}
                        </button> */}
                    </li>
                </ul>
            </div>
        </div>
        </>
    )
}

export default MembGameSvcMnyUi;
